// utils/tab-router-utils.js
import router from '@/router'; // 导入全局路由实例
import { v4 as uuidv4 } from 'uuid';

// export const getCurrentTabId = (tabIdKey = 'currentIndex') => {
//   // 使用全局路由的currentRoute
//   const route = router.currentRoute.value;
//   return route.query[tabIdKey] || `tab-${uuidv4()}`;
// };
/**
 * 获取当前标签页ID
 * @param {string} tabIdKey - 路由参数中标签页ID的键名
 * @returns {string} 当前标签页ID
 */
export const getCurrentTabId = (tabIdKey = 'currentIndex') => {
  // 使用全局路由的currentRoute
  const route = router.currentRoute.value;
  return route.query[tabIdKey];
};
export const getCountTab = () => {
  let tabCount: any = parseInt(localStorage.getItem('tabCount') || '0');
  localStorage.setItem('tabCount', tabCount + 1);
  return tabCount;
};
/**
 * 生成基于标签页的持久化存储键
 * @param {string} storeId - Pinia Store的ID
 * @param {string} tabIdKey - 路由参数中标签页ID的键名
 * @returns {string} 持久化存储键
 */
export const getPersistKey = (storeId, tabIdKey = 'currentIndex') => {
  return `${storeId}-${getCurrentTabId(tabIdKey)}`;
};

/**
 * 在新标签页打开路由，并传递当前标签页ID
 * @param {string | import('vue-router').RouteLocationRaw} to - 目标路由
 * @param {string} windowFeatures - window.open的特性参数
 * @returns {Window | null} 新打开的窗口引用
 */
export const openInNewTab = (to, windowFeatures = 'noopener,noreferrer') => {
  return window.open(to, '_blank', windowFeatures);
};

/**
 * 获取 URL 中的所有查询参数
 * @param {string} [url] - 可选的 URL 字符串，默认为当前 URL
 * @returns {Object} - 包含所有参数的对象，如果没有参数则返回空对象
 */
function getAllUrlParams(url = window.location.href) {
  try {
    // 创建 URL 对象
    const urlObj = new URL(url);

    // 使用 URLSearchParams 获取所有参数
    const searchParams = urlObj.searchParams;

    // 将参数转换为对象
    const params = {};
    searchParams.forEach((value, key) => {
      // 处理重复参数（如 ?id=1&id=2），转为数组
      if (params[key] !== undefined) {
        if (!Array.isArray(params[key])) {
          params[key] = [params[key]];
        }
        params[key].push(decodeURIComponent(value));
      } else {
        params[key] = decodeURIComponent(value);
      }
    });

    return params;
  } catch (error) {
    console.error('解析 URL 失败:', error);
    return {};
  }
}

/**
 * 获取当前标签页的所有store持久化数据
 * @param {string} tabIdKey - 路由参数中标签页ID的键名
 * @returns {Record<string, any>} 所有store的持久化数据
 */
export const getAllTabPersistedData = (tabIdKey = 'currentIndex') => {
  const tabId = getCurrentTabId(tabIdKey);
  const result = {};

  // 遍历localStorage，收集所有属于当前标签页的store数据
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key && key.endsWith(`-${tabId}`)) {
      const storeId = key.split(`-${tabId}`)[0];
      try {
        result[storeId] = JSON.parse(localStorage.getItem(key) || 'null');
      } catch (e) {
        console.error(`解析store数据失败: ${storeId}`, e);
      }
    }
  }

  return result;
};

/**
 * 清除当前标签页的所有持久化数据
 * @param {string} tabIdKey - 路由参数中标签页ID的键名
 */
export const clearCurrentTabData = (tabIdKey = 'currentIndex') => {
  const tabId = getCurrentTabId(tabIdKey);

  // 遍历localStorage，删除所有属于当前标签页的store数据
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key && key.endsWith(`-${tabId}`)) {
      localStorage.removeItem(key);
    }
  }
};
/**
 * 限制输入框只能输入数字和小数点
 * @param {Event} e - 输入事件对象
 * @description 支持输入正负数和小数，自动过滤非法字符，保留合法的数字格式
 */
export const onlyNumber = (e) => {
  if (!/^-?\d*\.?\d*$/.test(e.target.value)) {
    e.target.value = e.target.value
      .replace(/[^\d.-]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/^([^.]*\.)|\./g, '$1');
  }
};
